<div class="modal-header">
    <h4 class="modal-title" id="modal-title">
      {{ 'customStockProtection.instructions.title' | cxTranslate }}
    </h4>
    <button
      type="button"
      class="close"
      aria-describedby="modal-title"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="container-fluid">
      <div class="instructionsParagraph"[innerHTML]="'customStockProtection.instructions.informationParagraph' | cxTranslate"></div>
      <div class="instructionsParagraph" [innerHTML]="'customStockProtection.instructions.informationParagraphContinued' | cxTranslate"></div>

      <div class="importParagraph">
          {{ 'customStockProtection.instructions.importCsvParagraph' | cxTranslate }}
          <a href="assets/files/example-csv-file.csv">
          {{ 'customStockProtection.instructions.downloadLink' | cxTranslate }}</a>
          {{ 'customStockProtection.instructions.importCsvParagraphContinued' | cxTranslate }}
      </div>
      <br>
      <p class="statesHeader">{{ 'customStockProtection.instructions.statesHeader' | cxTranslate }}</p>
      <div class="states">
          <div class="row">
            <div class="col-2 col-sm-2">
              <img src="assets/images/orderhistory/state_new.gif"
              title="{{'customStockProtection.states.new' | cxTranslate}}"
              />
            </div>
            <div class="col-6 col-sm-8">
              {{ 'customStockProtection.states.new' | cxTranslate }}
            </div>
          </div>
          <div class="row">
            <div class="col-2 col-sm-2">
              <img src="assets/images/orderhistory/state_completed.gif"
              title="{{'customStockProtection.states.finishedWithCredit' | cxTranslate}}"
              />
            </div>
            <div class="col-6 col-sm-8">
              {{ 'customStockProtection.states.finishedWithCredit' | cxTranslate }}
            </div>
          </div>
          <div class="row">
            <div class="col-2 col-sm-2">
              <img src="assets/images/orderhistory/state_with_open_positions.gif"
              title="{{'customStockProtection.states.finishedWithoutCredit' | cxTranslate}}"
              />
            </div>
            <div class="col-6 col-sm-8">
              {{ 'customStockProtection.states.finishedWithoutCredit' | cxTranslate }}
            </div>
          </div>
          <div class="row">
            <div class="col-2 col-sm-2">
              <img src="assets/images/stockprotection/07.gif"
              title="{{'customStockProtection.states.07' | cxTranslate}}"
              />
            </div>
            <div class="col-6 col-sm-8">
              {{ 'customStockProtection.states.07' | cxTranslate }}
            </div>
          </div>
        </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modal.dismiss('cancel click')"
    >
    {{ 'customStockProtection.instructions.close' | cxTranslate }}
    </button>
  </div>
